import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { SelectProps } from '@mui/material/Select/Select';
import { filter, get, map } from 'lodash';
import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { getDistrictWarehouse } from '../../../thunks/district-thunks';

interface DistrictsSelectProps extends SelectProps {
  className?: string;
  region?: string | number;
  error?: boolean;
  helperText?: string;
  InputProps?: Record<string, any>;
}

export const DistrictsSelect: ComponentType<DistrictsSelectProps> = ({
  region,
  label,
  error = false,
  helperText,
  InputProps,
  ...props
}) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { warehouse } = useSelector((state: RootStateOrAny) => state.district);

  const value = String(get(props, 'value', ''));
  const list = region ? filter(warehouse.hits, (x) => x.region === region) : warehouse.hits;
  const options = map(list, (item, idx) => (
    <MenuItem value={get(item, 'id', '')} key={idx}>
      {get(item, ['title', i18n.language], 'None')}
    </MenuItem>
  ));

  useEffect(() => {
    dispatch(getDistrictWarehouse());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl error={error} fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select {...{ ...props, label, value }}>{options}</Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
